// This file is automatically generated by scripts/build-corejs3-shipped-proposals.mjs

export default new Set<string>([
  "esnext.array.find-last",
  "esnext.array.find-last-index",
  "esnext.typed-array.find-last",
  "esnext.typed-array.find-last-index",
]);
